module.exports = __webpack_public_path__ + "static/media/erp.0c09e0fd.svg";